<template>
  <b-row>
    <b-col md="12">
      <b-card>
        <b-row>
          <b-col sm="12">
            <b-row>
              <b-col sm="4">
                <span class="pr-"><strong>총 {{items.length}}건</strong></span>
                <span style="color:#ea0000; font-weight:bold; font-size:15px" v-if="drDeleteRows.length == 0">* 가장 최근글이 사용자에게 안내됩니다.</span>
                <span style="color:#222222; font-weight:bold; font-size:15px" v-if="drDeleteRows.length > 0">선택된 데이터 : {{drDeleteRows.length}}</span>
                <!-- <b-button size="sm" variant="info" v-on:click="joinGuideDeleteClear()" :disabled="drDeleteRows.length == 0" :class="drDeleteRows.length != 0 ? 'mx-1 clear_button_on' : 'mx-1 clear_button_off'"><h5 style="margin-bottom:0px"><i class="fa fa-list"></i> 초기화</h5></b-button> -->
              </b-col>
              <b-col sm="3"></b-col>
              <b-col sm="4" class="my-1">
                <b-button variant="outline-danger" style="float:right" v-on:click="joinGuideDelete()" :disabled="drDeleteRows.length == 0" :class="drDeleteRows.length != 0 ? 'mx-1' : 'mx-1'">삭제</b-button>
              </b-col>
              <b-col md="1" class="my-1">
                <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="pt-sm-1">
            <b-row>
              <b-col sm="1"></b-col>
              <b-col sm="12">
                <b-table
                  striped
                  hover
                  :fields="fieldItems"
                  :items="items"
                  :busy="items == 0"
                  :current-page="currentPage"
                  :per-page="perPage">
                  <div slot="table-busy" class="text-center my-2">
                    <strong>데이터가 없습니다.</strong>
                  </div>
                  <template slot="selectcheck" slot-scope="data">
                    <div>
                      <input type="checkbox" class="datarows" v-model="data.item.selectchecked" v-on:change="drListRows(data.item)" style="vertical-align:middle; width:20px; height:20px">
                    </div>
                  </template>
                  <template slot="rnum" slot-scope="data">
                    <div>{{data.item.rnum}}</div>
                  </template>
                  <!-- <template slot="use_yn" slot-scope="data">
                    <div>
                      <c-switch type="text" variant="primary" v-model="data.item.use_yn" v-on:change="useSwitch(data.item,data.item.guide_id)" on="On" off="Off" :pill="true" :checked="true" style="margin:0px"/>
                    </div>
                  </template> -->
                  <template slot="title" slot-scope="data">
                    <div><a href="javascript:void(0)" v-on:click="joinGuideInfoGo(data.item)">{{data.item.title}}</a></div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="pt-sm-1">
            <b-row class="pb-sm-2">
              <b-col sm="1"></b-col>
              <b-col sm="12" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="listRows"
                  :per-page="perPage"
                  align="center"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <div style="float:right">
          <b-button variant="info" style="color:#ffffff" v-bind:href="'#/customer/joinguide/form?status=insert'">신규등록</b-button>
        </div>
      </b-card>
    </b-col>
  </b-row>



</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { codeAPI } from '../../common/code.js';
import swal from 'sweetalert2'
import cSwitch from '../../components/Switch'

const moment = require("moment");

export default {
  components: {
    cSwitch,
    DatePicker,
  },
  data() {
    return {
      // totalRows: 30,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 30, 50, 100],
      drDeleteRows: [],
      queryParams: {
        use_yn: 'Y',
      },
      fieldItems: [{
        'selectcheck': {
          'label': '선택',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      },{
        'rnum': {
          'label': '번호',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center'
          }
        }
      }, {
        // 'use_yn': {
        //   'label': '노출여부',
        //   'class': 'text-center',
        //   'thStyle': {
        //      'vertical-align': 'middle',
        //      'text-align': 'center'
        //   }
        // }
      }, {
        'title': {
          'label': '제목',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center'
          }
        }
      }, {
        'reg_date': {
          'label': '등록일',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'reg_id': {
          'label': '등록자',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }],
      items: [],
    }
  },
  computed: {
    listRows() {
      return this.items.length
    }
  },
  watch: {
  },
  mounted: function() {
    var self = this;
    self.init();
  },
  methods: {
    init() {
      var token = sessionStorage.getItem("myToken");
      var self = this;

      // 최초 날짜 갱신(이번달)
      // self.dateRange('this_month');

      // 최초 리스트 갱신
      self.findJoinGuideList();
    },
    // 회원가입안내 리스트 조회
    findJoinGuideList() {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.queryParams));

      var data = new FormData();
      data.append('objs', param);

      self.$http.post('/api/select/joinGuideList?access_token=' + token, data, null)
        .then((result) => {
          self.items = result.data;
          var itemCnt = self.items.length;
          self.items.forEach(function (el, idx, arr){
            el.rnum = itemCnt - (idx);
            el.selectchecked = false;
          });
        })
    },
    drListRows() {
      var self = this;
      self.drDeleteRows = [];
      self.items.forEach(function (el, idx, arr){
        if(el.selectchecked){
          self.drDeleteRows.push(el.guide_id);
        }
      });
    },
    joinGuideDelete(){
      var self = this;
      swal.fire({
        title: '회원가입안내 삭제!',
        // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
        html: "<b>현재의 회원가입안내에 저장된 데이터</br> 모두 삭제 됩니다. 삭제하시겠습니까?</br><span style='color:#ea0000'>삭제 데이터 수 : "+self.drDeleteRows.length+"건</span></b>",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          // ok
          console.log(self.drDeleteRows);
          var token = sessionStorage.getItem("myToken");
          var param = encodeURI(JSON.stringify(self.drDeleteRows));
          var data = new FormData();
          data.append('drDelArr', param);

          self.$http.post('/api/delete/joinGuideData?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '회원가입안내이 삭제되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                self.drDeleteRows = [];
                $(".datarows").prop("checked", false);
                self.findJoinGuideList();
              });
          })
        }else{
          // cansel
        }
      })
    },
    joinGuideDeleteClear() {
      this.drDeleteRows = [];
      this.items.forEach(function (el, idx, arr){
        el.selectchecked = false;
      });
    },
    joinGuideInfoGo(row) {
      var self = this;
      self.$session.set('joinGuideCode', row.guide_id);
      location.href = '#/customer/joinguide/info';
    },
    // useSwitch(item, guide_id) {
    //   var self = this;
    //   var token = sessionStorage.getItem("myToken");
    //   self.queryParams.reg_id = self.$session.get('userId');
    //   self.queryParams.guide_id = guide_id;
    //   self.queryParams.use_yn = item.use_yn;

    //   var param = encodeURI(JSON.stringify(self.queryParams));
    //   var data = new FormData();
    //   data.append('objs', param);

    //   self.$http.post('/api/update/faqUseYn?access_token='+token, data, null)
    //     .then((result) => {
    //       console.log("결과",result);
    //   })
    // },
  }
}
</script>
<style lang="css" scoped>
  .delete_button_on {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #f42f2d; font-size:15px}
  .delete_button_off {color:#ffffff; border-radius:5px; cursor:auto; border:1px solid #f42f2d; font-size:15px}
  .clear_button_on {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #55a0bb; font-size:15px}
  .clear_button_off {color:#ffffff; border-radius:5px; cursor:auto; border:1px solid #55a0bb; font-size:15px}
</style>



// WEBPACK FOOTER //
// src/views/customer/JoinGuide.vue